<template>
    <div class="d-flex justify-content-center flex-wrap py-3">
        <div class="col-12 col-sm-4 text-center bg-white shadow rounded p-5">
            <h3>
                {{ $t(`Auth.${this.$route.name}.RouteName`) }}
            </h3>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
    name: 'ForgotPasswordRequestInProgress',
    computed: {
        ...mapGetters(['apiPath', 'omsApiKey'])
    },
    methods: {
        ...mapMutations(['setErrorFromServer']),
        forgot_password() {
            this.$http
                .post(`${this.apiPath}/forgot_password`, { token: this.$route.query.token }, {
                    headers: {
                        "x-api-key": this.omsApiKey
                    },
                })
                .then((res) => {
                    switch (res.data) {
                        case 'Request Expired':
                            this.$toast.error(this.$t('Auth.RequestExpired.expired'))
                            this.$router.replace('/')
                            break;
                        default:
                            this.$router.replace({
                                path: '/reset_password',
                                query: { token: res.data }
                            })
                            break;
                    }
                })
                .catch((err) => {
                    this.setErrorFromServer(err.message)
                })
        }
    },
    created() {
        this.forgot_password()
    }
}
</script>